import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

function ProvencialAssessorGuard({ children }) {
  const account = useSelector((state) => state.account);
  const rolename = account?.user?.roles[0]?.name?.trim() ?? "";

  if (!account.user) {
    return <Redirect to="/login" />;
  }

  if (account.user.roles.length > 0 && rolename === "user") {
    return <Redirect to="/app" />;
  }

  if (account.user.roles.length > 0 && rolename === "admin") {
    return <Redirect to="/administrator" />;
  }

  if (
    account.user.roles.length > 0 &&
    rolename === "report analyst treasurer"
  ) {
    return <Redirect to="/report-analyst-treasurer" />;
  }

  if (account.user.roles.length > 0 && rolename === "report analyst assessor") {
    return <Redirect to="/report-analyst-assessor" />;
  }

  if (
    account.user.roles.length > 0 &&
    rolename === "provencial report analyst treasurer"
  ) {
    return <Redirect to="/provencial-report-analyst-treasurer" />;
  }

  return children;
}

ProvencialAssessorGuard.propTypes = {
  children: PropTypes.any,
};

export default ProvencialAssessorGuard;
